import { Suspense } from 'react';
import { CssBaseline } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useAppSelector } from 'store/hooks/useAppSelector';
import { getToastInfo } from 'store/selectors/settings';

import { ErrorBoundary } from 'components/common/ErrorBoundary';
import { RootRoutes } from 'components/common/RootRoutes/RootRoutes';
import { Snackbar } from 'components/ui/Snackbar';
import { Spinner } from 'components/ui/Spinner';

import 'mapbox-gl/dist/mapbox-gl.css';

export const App = () => {
  const toastInfo = useAppSelector(getToastInfo);

  return (
    <ErrorBoundary>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        <Suspense fallback={<Spinner />}>
          <RootRoutes />
        </Suspense>
        {!!toastInfo?.message && (
          <Snackbar message={toastInfo.message} severity={toastInfo.severity} />
        )}
      </LocalizationProvider>
    </ErrorBoundary>
  );
};
